import { useRequestState } from "@/hooks";
import { useContext, useEffect } from "react";
import { trim } from "lodash";
import {
  DEFAULT_INBOX_FILTERS,
  DEFAULT_INBOX_PAGE_NUMBER,
  DEFAULT_INBOX_SUGGESTION_SIZE,
} from "../constants";
import { useApprovalsListProps } from "./types";
import { AuthContext } from "@/guards/auth/auth-context";
import { InboxFlatResponse } from "@/services/api/inbox/contracts";
import {
  requestApprovalsList,
  requestTrackingList,
} from "@/services/api/inbox/requests";

export const useSuggestionsList = ({
  isTracking,
  searchQuery,
  appliedFilters,
}: useApprovalsListProps) => {
  const { account } = useContext(AuthContext);

  const { isLoading, data, error, setSuccess, setError, setInProgress } =
    useRequestState<InboxFlatResponse>({ isLoading: true });

  useEffect(() => {
    setInProgress();

    const controller = new AbortController();
    const request = isTracking ? requestTrackingList : requestApprovalsList;

    if (searchQuery?.length) {
      request(
        {
          email: account?.username ?? "",
          filterText: searchQuery ? trim(searchQuery) : "",
          filters: isTracking ? appliedFilters : DEFAULT_INBOX_FILTERS,
          pageSize: DEFAULT_INBOX_SUGGESTION_SIZE,
          pageNumber: DEFAULT_INBOX_PAGE_NUMBER,
          isFlatResponse: true,
        },
        { signal: controller.signal },
      )
        .then(response => {
          setSuccess(response);
        })
        .catch(error => {
          setError(error);
        });
    }

    return () => {
      controller.abort();
    };
  }, [
    appliedFilters,
    isTracking,
    searchQuery,
    setError,
    setSuccess,
    account,
    setInProgress,
  ]);

  return {
    isLoading,
    data,
    error,
  };
};
